var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo } from 'react';
import { updateContext } from '../Datadog';
export var DatadogContext = createContext({
    appBuildVer: '',
    appNameVal: '',
    setAppBuildVer: function () { return null; },
    setAppName: function () { return null; },
    setAppLevelContext: function () { },
});
export var updateAppLevelCtx = function (appName, contextData) {
    var _a;
    if (appName && contextData) {
        var appData = (_a = {}, _a[appName] = contextData, _a);
        updateContext('appLevelData', appData);
    }
};
export var DatadogProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState(''), 2), customAppBuildVer = _b[0], setCustomAppBuildVer = _b[1];
    var _c = __read(useState(''), 2), appName = _c[0], setAppName = _c[1];
    var value = useMemo(function () { return ({
        appBuildVer: customAppBuildVer,
        appNameVal: appName,
        setAppBuildVer: setCustomAppBuildVer,
        setAppName: setAppName,
        setAppLevelContext: function (contextData) { return updateAppLevelCtx(appName, contextData); },
    }); }, [appName, customAppBuildVer]);
    return _jsx(DatadogContext.Provider, __assign({ value: value }, { children: children }), void 0);
};
//# sourceMappingURL=Provider.js.map